import {
    ApolloClient,
    InMemoryCache,
    HttpLink,
    ApolloLink,
    concat
  } from "@apollo/client";
  
   const authMiddleware = new ApolloLink(
     (operation: any, forward: any) => {
       const headers = {
        authorization: `Bearer ${localStorage.getItem("token")}`,
        };
       operation.setContext(() => ({
         headers: {
           ...headers,
         },
       }));
  
       return forward(operation);
     }
   );

  const uri = `${process.env.REACT_APP_SERVER_BASE_URL}/ncms/graphql`
  const httpLink = new HttpLink({
    uri: uri ,
  });
  
  const entitesClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authMiddleware, httpLink),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "network-only",
      },
      query: {
        fetchPolicy: "network-only",
      },
    },
  });
  
  export default entitesClient;